import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Popover } from '@material-ui/core';

import Paper from 'components/Paper';
import { LoadingPage } from 'components/Loading';
import Images from 'assets/img';
import SearchInput from 'components/SearchInput';
import Table from 'components/Table';
import Button from 'components/Button';
import InsurancesActions from 'store/ducks/insurances';
import { Row } from 'styles/components';

import { Container, WrapperTable, WrapperPopover, PopoverText, PopoverButton, EditIcon, DeleteIcon } from './styles';

function Insurances() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { insurances, isLoading } = useSelector((state) => state.insurances);
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [search, setSearch] = useState('');

  useEffect(() => {
    dispatch(InsurancesActions.getInsurancesRequest());
  }, [dispatch]);

  // if (isLoading) {
  //   return <LoadingPage />;
  // }

  const data = insurances.map((item) => ({
    ...item,
    actions: item.id,
    id: item.id,
    codigo: item.codigo || '-',
    nome_seguradora: item.nome_seguradora || '-',
    cnpj_seguradora: item.cnpj_seguradora || '-',
    numero_apolice: item.numero_apolice || '-',
    date: item.created_at ? new Date(item.created_at) : new Date(),
  }));

  const filteredData = data.filter(
    (item) =>
      (item.codigo || '').toUpperCase().includes(search.toUpperCase()) ||
      (item.nome_seguradora || '').toUpperCase().includes(search.toUpperCase()) ||
      (item.numero_apolice || '').toUpperCase().includes(search.toUpperCase())
  );

  const handleDeleteInsurance = (id) => {
    if (window.confirm('Tem certeza que deseja excluir este seguro?')) {
      dispatch(InsurancesActions.removeInsuranceRequest(id));
    }
  };

  return (
    <Container>
      <Paper
        title="Seguros"
        icon={Images.IconPaper}
        rightContent={
          <Row>
            <SearchInput
              onChange={(e) => setSearch(e.target.value)}
              onClear={() => setSearch('')}
              value={search}
            />
            <Button
              label="Novo Seguro"
              onClick={() => history.push('/insurances/new')}
              type="primary"
              width="150px"
              height="33px"
              margin="0 0 0 10px"
            />
          </Row>
        }
      >
        <WrapperTable>
          {isLoading ? (
            <LoadingPage />
          ) : (
            <Table
              columns={[
                { label: 'Ações', id: 'actions' },
                { label: 'Código', id: 'codigo' },
                { label: 'Nome da Seguradora', id: 'nome_seguradora' },
                { label: 'CNPJ da Seguradora', id: 'cnpj_seguradora' },
                { label: 'Número da Apólice', id: 'numero_apolice' },
                { label: 'Data de cadastro', id: 'date' },
              ]}
              activePage={0}
              totalPages={2}
              data={filteredData}
              customComponent={{
                actions: (e) => (
                  <Row>
                    <EditIcon
                      onClick={() => history.push(`/insurances/edit/${e}`)}
                      title="Editar seguro"
                    />
                    <DeleteIcon
                      onClick={(event) => {
                        setSelectedId(e);
                        setAnchorEl(event.currentTarget);
                        setOpen(true);
                      }}
                      title="Excluir seguro"
                    />
                  </Row>
                ),
                date: (e) => format(new Date(e), 'dd/MM/yyyy'),
              }}
            />
          )}
        </WrapperTable>
      </Paper>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => {
          setOpen(false);
          setSelectedId(null);
        }}
        placement="top"
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
      >
        <WrapperPopover>
          <PopoverText>Tem certeza?</PopoverText>
          <PopoverButton
            onClick={() => {
              dispatch(InsurancesActions.removeInsuranceRequest(selectedId));
              setSelectedId(null);
              setOpen(false);
            }}
          >
            Sim
          </PopoverButton>
        </WrapperPopover>
      </Popover>
    </Container>
  );
}

export default Insurances;

